import React, { useEffect, useState } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { useCartContext } from '../../context/cartContext';
import updateOrderAndCreateCards from '../../utils/updateOrderAndCreateCards';
import { Helmet } from 'react-helmet';

const PaymentComplete = () => {
  const [searchParams] = useSearchParams();
  const [hasRun, setHasRun] = useState(false);

  const orderId = searchParams.get('orderId');
  const payment_intent = searchParams.get('payment_intent');
  const redirect_status = searchParams.get('redirect_status');

  const navigate = useNavigate();

  const { clearCart } = useCartContext();

  if (!redirect_status) {
    setTimeout(() => {
      navigate('/');
    }, 5000);
  }

  useEffect(() => {
    const handleOrderUpdate = async () => {
      if (redirect_status === 'succeeded' && !hasRun) {
        try {
          clearCart(); // Synchronous operation, no need to await
          await updateOrderAndCreateCards(orderId, payment_intent); // Await the asynchronous operation
          setHasRun(true); // Set state after successful operation
          setTimeout(() => {
            navigate('/');
          }, 5000);
        } catch (error) {
          console.error('Fehler beim verarbeiten der Bestellung:', error);
        }
      }
    };

    handleOrderUpdate();
  }, [redirect_status, orderId, payment_intent, hasRun]);

  return redirect_status === 'failed' ? (
    <main className="py-24">
      <div className="px-4 py-16 text-center sm:px-6 lg:px-8">
        <h1 className="mt-2 text-4xl font-bold tracking-tight text-gray-900 sm:text-6xl">
          Da ist etwas schiefgelaufen...
        </h1>
      </div>
      <div className="text-center px-6">
        <p>Deine Zahlung war nicht erfolgreich</p>
        <p>Bitte versuche es nochmal.</p>
        <p>Deine Transaktionsnummer ist: {payment_intent}</p>
      </div>
    </main>
  ) : redirect_status === 'succeeded' ? (
    <main className="py-24">
      <div className="px-4 py-16 text-center sm:px-6 lg:px-8">
        <h1 className="mt-2 text-4xl font-bold tracking-tight text-gray-900 sm:text-6xl">
          Danke für deine Bestellung!
        </h1>
      </div>
      <div className="text-center px-6">
        <p>Deine Zahlung war erfolgreich!</p>
        <p>Du wirst gleich zur Startseite weitergeleitet.</p>
      </div>
      <Helmet>
        <script type="text/javascript">
          {`
            gtag('event', 'conversion_event_purchase', {
              // Add your event parameters here if needed
            });
          `}
        </script>
      </Helmet>
    </main>
  ) : (
    <div>Fehler</div>
  );
};

export default PaymentComplete;
